import * as fileAPIFuncs from "@/api/files";
import * as frontendAddonAPIFuncs from "@/api/frontendAddons";
import * as versionAPIFuncs from "@/api/version";
type apiFunctionNames =
  | keyof typeof fileAPIFuncs
  | keyof typeof frontendAddonAPIFuncs
  | keyof typeof versionAPIFuncs;

/**
 * APIレートリミット管理
 * 各APIエンドポイントのコストとレートリミット設定を管理
 * 参考: https://www.notion.so/algo-artis/SSUI-API-2025-07-07ver-184af951024b807897a6cf64f1f2fb91
 */

// API関数名とコストの定義
export const API_COSTS: Partial<Record<apiFunctionNames, number>> = {
  // File API functions
  postFileVersionSchemaUpdate: 3, // シートスキーマファイルによるバージョンの更新
  postFileVersionViews: 2, // ビュー設定の更新
  postFileVersionDataCSV: 3, // 特定シートデータのCSVアップロード
  postFileVersionDataExcel: 5, // バージョン内シートデータのExcelアップロード
  postFileVersionDataJSON: 5, // バージョン内シートデータのJSONアップロード
  getFileVersionDataJSON: 5, // バージョン内シートデータのJSONダウンロード
  getFileVersionDataExcel: 5, // バージョン内シートデータのExcelダウンロード
  getFileVersionDataCSV: 3, // バージョン内シートデータのCSVダウンロード
  getFileVersionSchema: 1, // シートスキーマの取得
  getFileVersionViews: 1, // ビュー設定の取得
  // FrontendAddon API functions
  postCreateFrontendAddon: 5, // フロントエンドアドオンの作成
} as const;

// レートリミット設定
export const RATE_LIMIT_CONFIG = {
  // 1秒間のウィンドウで最大コスト6まで
  MAX_COST_PER_WINDOW: 6,
} as const;

// APIコストを取得する関数
export const getApiCost = (functionName: keyof typeof API_COSTS): number => {
  return API_COSTS[functionName] || RATE_LIMIT_CONFIG.MAX_COST_PER_WINDOW;
};

// 与えられたAPIの同時実行可能数を取得する関数
export const getMaxConcurrentApiCount = (
  functionName: keyof typeof API_COSTS
): number => {
  return Math.floor(
    RATE_LIMIT_CONFIG.MAX_COST_PER_WINDOW / getApiCost(functionName)
  );
};
